import React, {useEffect, useState} from "react";

/** The fields of a server video job status (src/server/lib/video-render-jobs.ts) that the label shows. */
export type ServerVideoJobStatus = {
  state: "queued" | "rendering" | "done" | "failed" | "cancelled";
  ahead: number;
  framesDone: number;
  frameCount: number;
};

function describeJob(status: ServerVideoJobStatus | null): string {
  if (!status) return "Preparing video";
  switch (status.state) {
    case "queued":
      return status.ahead > 0 ? `Queued, ${status.ahead} ahead` : "Queued";
    case "rendering":
      return `Rendering ${Math.floor((status.framesDone / status.frameCount) * 100)}%`;
    case "done":
      return "Downloading video";
    case "failed":
    case "cancelled":
      return "Video export stopped";
  }
}

export function ServerVideoRenderStatus({
  status,
  tickMs = 1000,
}: {
  /** Null before the job starts: the scene is saved first. */
  status: ServerVideoJobStatus | null;
  tickMs?: number;
}) {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setElapsedSeconds((current) => current + 1);
    }, tickMs);
    return () => window.clearInterval(timer);
  }, [tickMs]);

  return (
    <span className="server-video-render-status" role="status" aria-live="polite">
      <span className="server-video-render-spinner" aria-hidden="true" />
      <span>
        {describeJob(status)} · {elapsedSeconds}s elapsed
      </span>
    </span>
  );
}
